import type {
  AvatarSizes,
  ThemeColorsBackground,
  ThemeColorsMeta,
} from '@frameio/vapor';
import { Avatar, AvatarGroup } from '@frameio/vapor';

export type PersonAvatarShape = {
  name?: string | null;
  email?: string | null;
  avatarUrl?: string | null;
  avatarColor?: string | null;
};

type AvatarForPersonProps = {
  person: PersonAvatarShape | null | undefined;
  size: AvatarSizes;
};

export const AvatarForPerson = ({ person, size }: AvatarForPersonProps) => {
  const altSource = person?.name || person?.email;

  if (!altSource) {
    return <Avatar shape="circle" size={size} />;
  }

  return (
    <Avatar
      alt={altSource}
      background={
        person?.avatarColor as ThemeColorsBackground | ThemeColorsMeta
      }
      shape="circle"
      size={size}
      src={person?.avatarUrl || undefined}
    />
  );
};

type FacepileForPeopleProps = {
  people: PersonAvatarShape[];
  size: AvatarSizes;
};

export const FacepileForPeople = ({ people, size }: FacepileForPeopleProps) => {
  if (people.length === 0) {
    return <AvatarForPerson person={null} size={size} />;
  }

  if (people.length === 1) {
    return <AvatarForPerson person={people[0]} size={size} />;
  }

  return (
    <AvatarGroup interactive={false} variant="angled">
      <AvatarForPerson person={people[0]} size={size} />
      <AvatarForPerson person={people[1]} size={size} />
    </AvatarGroup>
  );
};
